import type { Conflict } from '../db/types';
import { formatClock, formatDayMonth } from '../lib/dates';

/**
 * Last-write-wins resolves silently, so this log is the only way to know
 * whether conflicts are actually happening. Read-only, newest first, and never
 * synced — it is a record of what this device saw.
 */
export function ConflictLog({ conflicts }: { conflicts: Conflict[] }) {
  if (conflicts.length === 0) {
    return (
      <div className="empty">
        <div className="empty__title">No conflicts recorded</div>
        <div className="empty__hint">Local only — never synced.</div>
      </div>
    );
  }

  return (
    <div className="pane__scroll">
      <div className="pane__section">
        <div className="section-head" style={{ padding: '0 var(--panel-pad)' }}>
          <span>Recorded</span>
          <span className="section-head__count">{conflicts.length}</span>
        </div>
        {conflicts.map((c) => (
          <div className="row row--tall" key={c.id}>
            <div className="row__body">
              <div className="row__title">{c.title}</div>
              <div className="row__meta">
                {formatDayMonth(c.at)} {formatClock(c.at)} · {c.winner} won
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
